// Load polyfills (once, on the top of our web app)
import 'core-js/stable';
import 'regenerator-runtime/runtime';

import './index.css';

import { authClient } from '@40seas/auth-client';
import { isReevolHostname, getResolvedUrls } from '@40seas/frontend/libs/configs/consts';
import { datadogRumProvider } from '@40seas/frontend/libs/providers';
import { createRoot } from 'react-dom/client';
import { App } from './App';

const SOURCE_DASHBOARD_HOSTNAME = 'dashboard.40seas.com';
const TARGET_DASHBOARD_ORIGIN = 'https://dashboard.reevol.com';

if (window.location.hostname === SOURCE_DASHBOARD_HOSTNAME) {
    const pathWithQueryAndHash = `${window.location.pathname}${window.location.search}${window.location.hash}`;
    const redirectUrl = new URL(pathWithQueryAndHash, TARGET_DASHBOARD_ORIGIN);
    window.location.replace(redirectUrl.toString());
} else {
    // Resolve URLs at runtime based on hostname (Reevol vs 40Seas).
    // process.env.APP_URL / DASHBOARD_URL are baked at build-time as 40Seas defaults;
    // when the page is served from a Reevol domain we override with Reevol URLs.
    // For local dev / PR previews the baked env vars are used as-is.
    const resolvedUrls = isReevolHostname() ? getResolvedUrls() : undefined;

    // Configure authClient with hostname-resolved auth-v2 URL (Reevol vs 40Seas)
    const resolvedAuthV2Url = resolvedUrls?.AUTH_V2_URL ?? process.env.AUTH_V2_URL;
    if (resolvedAuthV2Url) {
        authClient.configure({ baseUrl: resolvedAuthV2Url });
    }

    const setup = {
        auth0: {
            domain: process.env.AUTH0_DOMAIN,
            clientId: process.env.AUTH0_CLIENT_ID,
        },
        urls: {
            APP_URL: resolvedUrls?.APP_PATH ?? process.env.APP_URL,
            API_URL: resolvedUrls?.API_PATH ?? process.env.API_URL,
            DASHBOARD_URL: resolvedUrls?.DASHBOARD_PATH ?? process.env.DASHBOARD_URL,
            REEVOL_DASHBOARD_URL: process.env.REEVOL_DASHBOARD_URL,
        },
        HOSTNAME: process.env.HOSTNAME,
    };

    // property for hubspot widget to disable load immediately
    window.hsConversationsSettings = { loadImmediately: false };
    (window as any).__SETUP__ = setup;

    datadogRumProvider.initDatadogRum({
        applicationId: 'd1f7779f-bba0-4074-8e5b-eea034dca26f',
        clientToken: 'pubfc9736b1d8711a363beb6f1e638ba6ae',
        service: 'dashboard',
    });

    const root = createRoot(document.getElementById('root')!);
    root.render(<App setup={setup as any} />);
}
